/* ═══════════════════════════════════════════════════════════════════════════════════
   HEIDI — COMMANDE RAPIDE PAR RÉFÉRENCE — 07/08/2026
   ═══════════════════════════════════════════════════════════════════════════════════
   Voir `sections/heidi-commande-rapide.liquid` pour le raisonnement d'ensemble et
   `sections/hs-sku.liquid` pour la résolution. Ce fichier ne fait que trois choses :
   découper la saisie, appeler le résolveur, poser le résultat dans le gabarit.

   IL NE CONSTRUIT JAMAIS DE HTML. Tout passe par le clonage du `<template>` de la
   section, puis par `textContent` et des attributs. Une valeur de catalogue — un titre
   produit, une marque — vient de vendeurs tiers : la traiter comme du balisage serait
   une injection à travers le catalogue.
   =============================================================================== */
(function () {
  'use strict';

  var CONCURRENCE = 4; // requêtes simultanées vers la vitrine, voir plus bas

  function demarrer() {
    var racine = document.querySelector('[data-hs-qo-root]');
    if (!racine) return;

    var elConfig  = racine.querySelector('[data-hs-qo-config]');
    var zone      = racine.querySelector('[data-hs-qo-zone]');
    var gabarit   = racine.querySelector('[data-hs-qo-gabarit]');
    var resultat  = racine.querySelector('[data-hs-qo-resultat]');
    var liste     = racine.querySelector('[data-hs-qo-liste]');
    var bilan     = racine.querySelector('[data-hs-qo-bilan]');
    var total     = racine.querySelector('[data-hs-qo-total]');
    var annonce   = racine.querySelector('[data-hs-qo-annonce]');
    var btnVerif  = racine.querySelector('[data-hs-qo-verifier]');
    var btnVider  = racine.querySelector('[data-hs-qo-vider]');
    var btnAjout  = racine.querySelector('[data-hs-qo-ajouter]');

    // Chaque élément est conditionnel dans le Liquid : un seul manquant et on ne fait
    // rien, plutôt que de jeter une exception au chargement de la page.
    if (!elConfig || !zone || !gabarit || !resultat || !liste || !btnVerif) return;

    var cfg;
    try { cfg = JSON.parse(elConfig.textContent); } catch (e) { return; }
    var L = (cfg && cfg.libelles) || {};

    /* ── Format monétaire, déduit d'un échantillon rendu par le serveur ───────────
       `cfg.gabarit_prix` est le rendu de 1 234 567,89 dans la devise du marché, par le
       même filtre `| money` que les prix de ligne. On en extrait la convention plutôt que
       de la supposer : préfixe, suffixe, séparateur de milliers, séparateur décimal.
       C'est ce qui garantit que le total s'écrit comme les lignes au-dessus de lui, en
       francs comme en euros, sans qu'aucune devise soit codée ici.                     */
    function analyser(gabarit) {
      if (!gabarit) return null;
      var i = gabarit.search(/\d/);
      if (i < 0) return null;
      var j = gabarit.length;
      while (j > 0 && !/\d/.test(gabarit.charAt(j - 1))) j--;

      var zone = gabarit.slice(i, j);
      var seps = zone.split(/\d+/).filter(Boolean);
      var sepMil = seps.length > 1 ? seps[0] : '';
      var sepDec = seps.length ? seps[seps.length - 1] : '';
      var dec = 0;

      if (seps.length) {
        var apres = zone.split(sepDec).pop();
        dec = /^\d+$/.test(apres) ? apres.length : 0;
        // Plus de deux décimales signifie qu'on a pris un séparateur de milliers pour un
        // séparateur décimal : la devise n'a alors pas de décimales du tout.
        if (dec > 2) { dec = 0; sepDec = ''; sepMil = seps[0]; }
      }

      return {
        prefixe: gabarit.slice(0, i),
        suffixe: gabarit.slice(j),
        sepMil: sepMil,
        sepDec: sepDec,
        dec: dec
      };
    }

    var fmt = analyser(cfg.gabarit_prix);

    function formater(cents) {
      if (!fmt) return '';
      var v = Math.abs(cents) / 100;
      var s = fmt.dec ? v.toFixed(fmt.dec) : String(Math.round(v));
      var bloc = s.split('.');
      var ent = bloc[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ').split(' ').join(fmt.sepMil);
      return (cents < 0 ? '-' : '') + fmt.prefixe + ent +
             (fmt.dec ? fmt.sepDec + (bloc[1] || '') : '') + fmt.suffixe;
    }

    var lignes = []; // état courant, seule source de vérité de l'affichage

    /* ── Découpage de la saisie ──────────────────────────────────────────────────
       LE SÉPARATEUR EST LE POINT-VIRGULE OU LA TABULATION, JAMAIS L'ESPACE.
       Mesuré sur le catalogue : 153 SKU contiennent une espace. Découper dessus
       casserait ces 153 références — « SKH 361 A » deviendrait « SKH » suivi d'un
       reliquat. La tabulation couvre le collage depuis un tableur, cas d'usage réel.

       `^(.*)[;\t]\s*(\d{1,4})\s*$` : le `.*` est GLOUTON, il capture donc jusqu'à la
       DERNIÈRE occurrence du séparateur. C'est ce qui permet aux 25 SKU contenant
       eux-mêmes un point-virgule de rester intacts.                                */
    function decouper(texte, max) {
      var out = [];
      var brut = String(texte || '').split(/\r?\n/);
      for (var i = 0; i < brut.length; i++) {
        var l = brut[i].trim();
        if (!l) continue;
        var ref = l, qte = 1;
        var m = l.match(/^(.*)[;\t]\s*(\d{1,4})\s*$/);
        if (m && m[1].trim()) {
          ref = m[1].trim();
          qte = parseInt(m[2], 10) || 1;
        }
        if (!ref) continue;
        out.push({ ref: ref, qte: qte > 0 ? qte : 1 });
        if (out.length >= max) break;
      }
      return out;
    }

    /* ── Résolution d'une référence ───────────────────────────────────────────── */
    function resoudre(ref) {
      var u = cfg.recherche +
        '?q=' + encodeURIComponent(ref) +
        '&resources[type]=product' +
        '&resources[options][fields]=variants.sku' +
        '&resources[limit]=10' +
        '&section_id=hs-sku';

      return fetch(u, { headers: { Accept: 'text/html' } })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (t) {
          // L'API de rendu de section enveloppe la réponse dans un `<div
          // class="shopify-section">`. On extrait le bloc JSON au lieu de parser la
          // réponse entière, qui n'est pas du JSON.
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var el = doc.querySelector('[data-hs-sku]');
          if (!el) return null;
          return JSON.parse(el.textContent);
        });
    }

    /* REPLI SUR L'ESPACE, ET SEULEMENT APRÈS UN ÉCHEC.
       « 1000042 5 » est ce qu'un acheteur tape spontanément. On ne peut pas découper
       sur l'espace d'emblée — voir plus haut, 153 SKU en contiennent — mais rien
       n'interdit de réessayer une fois que la ligne entière s'est révélée introuvable.
       Le coût est d'une requête supplémentaire sur les seules lignes en échec. */
    function resoudreAvecRepli(entree) {
      return resoudre(entree.ref)
        .then(function (j) {
          if (j && j.n > 0) return { entree: entree, res: j };
          var m = entree.ref.match(/^(.+?)\s+(\d{1,4})$/);
          if (!m) return { entree: entree, res: j };
          return resoudre(m[1]).then(function (j2) {
            if (j2 && j2.n > 0) {
              return { entree: { ref: m[1], qte: parseInt(m[2], 10) || 1 }, res: j2 };
            }
            return { entree: entree, res: j };
          });
        })
        .catch(function () { return { entree: entree, res: null, erreur: true }; });
    }

    /* ── File d'attente ──────────────────────────────────────────────────────────
       UNE REQUÊTE PAR LIGNE, QUATRE À LA FOIS. La vitrine finit par limiter le débit
       — c'est documenté, et une liste de cinquante références lancée d'un bloc est
       exactement le profil qui le déclenche. Quatre en parallèle tient le temps de
       réponse acceptable sans ressembler à un balayage.                              */
    function enFile(items, n, travail) {
      var i = 0;
      var res = new Array(items.length);
      function suivant() {
        if (i >= items.length) return Promise.resolve();
        var k = i++;
        return travail(items[k]).then(function (v) {
          res[k] = v;
          return suivant();
        });
      }
      var lanceurs = [];
      for (var j = 0; j < Math.min(n, items.length); j++) lanceurs.push(suivant());
      return Promise.all(lanceurs).then(function () { return res; });
    }

    /* ── Rendu ───────────────────────────────────────────────────────────────── */
    function texte(modele, remplacements) {
      var s = String(modele || '');
      for (var cle in remplacements) {
        if (Object.prototype.hasOwnProperty.call(remplacements, cle)) {
          s = s.split('[' + cle + ']').join(remplacements[cle]);
        }
      }
      return s;
    }

    function poser(el, champ, valeur) {
      var c = el.querySelector('[data-champ="' + champ + '"]');
      if (c) c.textContent = valeur;
      return c;
    }

    function dessiner() {
      liste.textContent = '';
      var somme = 0;
      var reconnues = 0;

      lignes.forEach(function (ligne, index) {
        var noeud = gabarit.content.firstElementChild.cloneNode(true);
        noeud.dataset.index = String(index);

        var a = ligne.article;
        poser(noeud, 'sku', ligne.ref);

        var alerte = noeud.querySelector('[data-champ="alerte"]');
        var nom    = noeud.querySelector('[data-champ="titre"]');
        var champQte = noeud.querySelector('[data-champ="qte"]');
        var img    = noeud.querySelector('.hs-qo__img');

        if (!a) {
          noeud.classList.add('hs-qo__ligne--absente');
          if (nom) { nom.textContent = L.introuvable || ''; nom.removeAttribute('href'); }
          if (champQte) champQte.disabled = true;
        } else {
          reconnues++;
          if (nom) {
            // `option` vaut « Default Title » sur un produit sans variante : Shopify le
            // renvoie tel quel, et l'afficher serait un défaut visible. On ne l'ajoute
            // qu'à une vraie variante.
            var titre = a.titre;
            if (a.option && a.option !== 'Default Title') titre += ' — ' + a.option;
            nom.textContent = titre;
            nom.href = a.url;
          }
          poser(noeud, 'marque', a.marque || '');
          poser(noeud, 'prix', a.prix || '');
          if (img && a.image) { img.src = a.image; img.alt = ''; img.hidden = false; }
          if (champQte) champQte.value = String(ligne.qte);

          if (!a.dispo) {
            noeud.classList.add('hs-qo__ligne--indispo');
            if (alerte) { alerte.textContent = L.indisponible || ''; alerte.hidden = false; }
          } else if (ligne.n > 1) {
            // 58 SKU du catalogue sont portés par plus d'une variante : on le dit au
            // lieu d'ajouter en silence un article que l'acheteur n'a pas choisi.
            if (alerte) {
              alerte.textContent = texte(L.ambigu, { count: ligne.n });
              alerte.hidden = false;
            }
          }
          if (a.dispo) somme += (a.prix_cents || 0) * ligne.qte;
        }

        liste.appendChild(noeud);
      });

      if (bilan) {
        bilan.textContent = texte(L.bilan, { found: reconnues, total: lignes.length });
      }
      if (total) total.textContent = formater(somme);
      if (btnAjout) btnAjout.disabled = reconnues === 0;
      resultat.hidden = lignes.length === 0;
      if (annonce) {
        annonce.textContent = texte(L.bilan, { found: reconnues, total: lignes.length });
      }
    }

    /* ── Vérification ────────────────────────────────────────────────────────── */
    function verifier() {
      var max = cfg.max || 50;
      var brut = decouper(zone.value, max + 1);

      if (!brut.length) {
        lignes = [];
        resultat.hidden = true;
        if (annonce) annonce.textContent = L.vide || '';
        zone.focus();
        return;
      }

      var tropLong = brut.length > max;
      var entrees = tropLong ? brut.slice(0, max) : brut;

      btnVerif.disabled = true;
      btnVerif.textContent = L.verification || '';
      if (annonce) annonce.textContent = L.verification || '';

      enFile(entrees, CONCURRENCE, resoudreAvecRepli)
        .then(function (res) {
          lignes = res.map(function (r) {
            return {
              ref: r.entree.ref,
              qte: r.entree.qte,
              n: r.res ? r.res.n : 0,
              article: r.res && r.res.article ? r.res.article : null
            };
          });
          dessiner();
          if (tropLong && bilan) {
            bilan.textContent += ' — ' + texte(L.trop, { count: max });
          }
        })
        .catch(function () {
          if (bilan) bilan.textContent = L.erreur || '';
          resultat.hidden = false;
        })
        .then(function () {
          btnVerif.disabled = false;
          btnVerif.textContent = L.verifier || '';
        });
    }

    /* ── Ajout au panier ─────────────────────────────────────────────────────── */
    function ajouter() {
      var items = lignes
        .filter(function (l) { return l.article && l.article.dispo; })
        .map(function (l) { return { id: l.article.variante, quantity: l.qte }; });

      if (!items.length) return;

      btnAjout.disabled = true;
      btnAjout.textContent = L.ajout || '';

      fetch(cfg.ajout + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.json();
        })
        .then(function () {
          // On mène au PANIER et non au tiroir. L'acheteur vient de poser vingt lignes :
          // il veut les relire en pleine largeur, avec les quantités modifiables et le
          // total qui engage — pas les survoler dans une colonne de 500 px.
          window.location.href = cfg.panier;
        })
        .catch(function () {
          if (bilan) bilan.textContent = L.erreur || '';
          btnAjout.disabled = false;
          btnAjout.textContent = L.ajouter || '';
        });
    }

    /* ── Transfert vers la demande de devis ──────────────────────────────────────
       Le lien porte une vraie `href` vers la page devis : sans JavaScript, ou si
       `heidi-quote.js` n'est pas chargé, il navigue normalement. On n'intercepte que
       s'il y a quelque chose à transférer ET que la porte publique existe.

       TOUTES LES LIGNES RÉSOLUES PARTENT, Y COMPRIS LES INDISPONIBLES — à la différence
       de l'ajout au panier, qui les écarte. Demander sous quel délai on peut obtenir une
       référence en rupture est précisément ce à quoi sert un devis ; l'écarter ici
       priverait l'acheteur de la seule question qu'il ne peut pas résoudre seul.

       AJOUT ET NON REMPLACEMENT : `HSQuote.add` cumule les quantités sur une variante
       déjà présente. Une liste de devis constituée ailleurs — fiche produit, panier — ne
       doit pas être effacée parce qu'on arrive par cette page.

       UN SEUL HORODATAGE POUR TOUT LE LOT, comme le fait déjà le transfert depuis le
       panier : ces lignes sont un même geste, pas N gestes séparés. */
    function versDevis(e) {
      if (!window.HSQuote || typeof window.HSQuote.add !== 'function') return;

      var aTransferer = lignes.filter(function (l) {
        return l.article && l.article.variante && l.article.handle;
      });
      if (!aTransferer.length) return;

      e.preventDefault();

      var stamp = new Date().toISOString();
      aTransferer.forEach(function (l) {
        window.HSQuote.add(l.article.variante, l.article.handle, l.qte, stamp);
      });

      // La navigation EST le retour : la page devis affiche la liste qu'on vient d'y
      // verser. Un message ici serait vu une fraction de seconde.
      window.location.href = e.currentTarget.href;
    }

    /* ── Écouteurs ───────────────────────────────────────────────────────────────
       Ceux de la liste sont DÉLÉGUÉS : elle est entièrement redessinée à chaque
       vérification, un écouteur posé sur une ligne ne survivrait pas au premier
       redessin.                                                                    */
    btnVerif.addEventListener('click', verifier);
    if (btnAjout) btnAjout.addEventListener('click', ajouter);

    var lienDevis = racine.querySelector('[data-hs-qo-devis]');
    if (lienDevis) lienDevis.addEventListener('click', versDevis);

    if (btnVider) {
      btnVider.addEventListener('click', function () {
        zone.value = '';
        lignes = [];
        resultat.hidden = true;
        zone.focus();
      });
    }

    // Ctrl/Cmd + Entrée depuis la zone de saisie : le raccourci attendu de qui colle une
    // liste et ne veut pas reprendre la souris.
    zone.addEventListener('keydown', function (e) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'Enter') {
        e.preventDefault();
        verifier();
      }
    });

    liste.addEventListener('click', function (e) {
      var b = e.target.closest('[data-champ="retirer"]');
      if (!b) return;
      var li = b.closest('.hs-qo__ligne');
      if (!li) return;
      var i = parseInt(li.dataset.index, 10);
      if (isNaN(i)) return;
      lignes.splice(i, 1);
      dessiner();
    });

    liste.addEventListener('change', function (e) {
      var c = e.target.closest('[data-champ="qte"]');
      if (!c) return;
      var li = c.closest('.hs-qo__ligne');
      if (!li) return;
      var i = parseInt(li.dataset.index, 10);
      if (isNaN(i) || !lignes[i]) return;
      var v = parseInt(c.value, 10);
      lignes[i].qte = v > 0 ? v : 1;
      c.value = String(lignes[i].qte);
      dessiner();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();
